export default __webpack_public_path__ + "static/hcstudent-slide-9f3dafe2cec7e5080c8f4c0cf55cae1f.png";